/* ============================================
   NIVODA DIAMOND INTEGRATION
   ============================================ */

(function() {
  'use strict';

  // ============================================
  // CONFIGURATION
  // ============================================
  const NIVODA_CONFIG = {
    text: {
      buttonText: "SELECT DIAMOND",
      colourLabel: null,
      clarityLabel: null,
      cutLabel: null,
      certificateText: null,
    },

    timing: {
      initialDelay: 500,
      secondCheck: 1000,
      thirdCheck: 2000,
    },

    selectors: {
      card: '.diamond-proxy-product-card',
      button: '.diamond-proxy-add-to-cart',
      buttonText: '.diamond-proxy-add-to-cart h3',
      colourLabel: '.view-details-subtitle-label',
      certificate: '.sc-hwddKA, .bbSYHF',
      productInfo: '.product-info',
    },

    features: {
      captureAndHold: true,
      redirectToCart: true,
      showInProductInfo: true,
    }
  };

  // ============================================
  // STATE MANAGEMENT
  // ============================================
  window.selectedDiamond = {
    isSelected: false,
    variantId: null,
    price: null,
    priceFormatted: null,
    title: null,
    carat: null,
    shape: null,
    color: null,
    clarity: null,
    cut: null,
    certificate: null,
    type: null, // Natural or Lab
    details: null,
  };


  // ============================================
  // TEXT CUSTOMIZATION
  // ============================================
  function customizeNivodaText() {
    const buttons = document.querySelectorAll(NIVODA_CONFIG.selectors.buttonText);
    buttons.forEach(btn => {
      if (btn.textContent.includes('Add to cart') && NIVODA_CONFIG.text.buttonText) {
        btn.textContent = NIVODA_CONFIG.text.buttonText;
      }
    });

    if (NIVODA_CONFIG.text.colourLabel) {
      document.querySelectorAll(NIVODA_CONFIG.selectors.colourLabel).forEach(label => {
        if (label.textContent.includes('Colour:')) {
          label.textContent = NIVODA_CONFIG.text.colourLabel;
        }
      });
    }

    if (NIVODA_CONFIG.text.clarityLabel) {
      document.querySelectorAll(NIVODA_CONFIG.selectors.colourLabel).forEach(label => {
        if (label.textContent.includes('Clarity:')) {
          label.textContent = NIVODA_CONFIG.text.clarityLabel;
        }
      });
    }

    if (NIVODA_CONFIG.text.cutLabel) {
      document.querySelectorAll(NIVODA_CONFIG.selectors.colourLabel).forEach(label => {
        if (label.textContent.includes('Cut:')) {
          label.textContent = NIVODA_CONFIG.text.cutLabel;
        }
      });
    }

    if (NIVODA_CONFIG.text.certificateText) {
      document.querySelectorAll(NIVODA_CONFIG.selectors.certificate).forEach(cert => {
        if (cert.textContent.includes('Certified')) {
          cert.textContent = NIVODA_CONFIG.text.certificateText;
        }
      });
    }
  }


  // ============================================
  // DIAMOND DATA EXTRACTION
  // ============================================
  function extractDiamondData(diamondCard) {
    const data = {
      variantId: null,
      price: null,
      priceFormatted: null,
      title: null,
      carat: null,
      shape: null,
      color: null,
      clarity: null,
      cut: null,
      certificate: null,
      type: null,
      details: null,
    };

    try {
      const priceElement = diamondCard.querySelector('.sc-fbQrwq, [class*="price"]');
      if (priceElement) {
        data.priceFormatted = priceElement.textContent.trim();
        const priceMatch = data.priceFormatted.match(/[\d,]+\.?\d*/);
        if (priceMatch) {
          data.price = parseFloat(priceMatch[0].replace(/,/g, ''));
        }
      }

      const titleElement = diamondCard.querySelector('.diamond-proxy-diamond-title h3, h3');
      if (titleElement) {
        data.title = titleElement.textContent.trim();
        
        const caratMatch = data.title.match(/(\d+\.?\d*)\s*ct/i);
        if (caratMatch) data.carat = caratMatch[1];
        
        const shapes = ['Round', 'Oval', 'Emerald', 'Princess', 'Cushion', 'Pear', 'Marquise', 'Heart', 'Radiant'];
        for (const shape of shapes) {
          if (data.title.includes(shape)) {
            data.shape = shape;
            break;
          }
        }
        
        if (data.title.includes('Natural')) data.type = 'Natural';
        else if (data.title.includes('Lab')) data.type = 'Lab Grown';
      }

      const detailsElements = diamondCard.querySelectorAll('.view-details-subtitle');
      detailsElements.forEach((detail) => {
        const label = detail.querySelector('.view-details-subtitle-label');
        const value = detail.querySelector('.view-details-subtitle-value');
        
        if (label && value) {
          const labelText = label.textContent.trim().replace(':', '').toLowerCase();
          const valueText = value.textContent.trim();
          
          if (labelText.includes('colour') || labelText.includes('color')) data.color = valueText;
          else if (labelText.includes('clarity')) data.clarity = valueText;
          else if (labelText.includes('cut')) data.cut = valueText;
        }
      });

      const detailsParts = [];
      if (data.color) detailsParts.push(`${data.color} Colour`);
      if (data.clarity) detailsParts.push(`${data.clarity} Clarity`);
      if (data.cut) detailsParts.push(`${data.cut} Cut`);
      data.details = detailsParts.join(', ');

      const certElement = diamondCard.querySelector('.sc-hwddKA, .bbSYHF');
      if (certElement) data.certificate = certElement.textContent.trim();

      // Try multiple methods to find variant ID
      const form = diamondCard.querySelector('form');
      if (form) {
        const variantInput = form.querySelector('input[name="id"]');
        if (variantInput) data.variantId = variantInput.value;
      }
      
      const button = diamondCard.querySelector(NIVODA_CONFIG.selectors.button);
      if (!data.variantId && button) {
        data.variantId = button.getAttribute('data-variant-id') || 
                        button.getAttribute('data-product-id') ||
                        button.getAttribute('data-id') ||
                        button.getAttribute('data-variantid');
      }

      if (!data.variantId && diamondCard) {
        data.variantId = diamondCard.getAttribute('data-variant-id') ||
                        diamondCard.getAttribute('data-product-id') ||
                        diamondCard.getAttribute('data-id') ||
                        diamondCard.getAttribute('data-variantid');
      }

      if (!data.variantId) {
        const hiddenInputs = diamondCard.querySelectorAll('input[type="hidden"]');
        hiddenInputs.forEach(input => {
          if (input.name === 'id' || input.name === 'variant_id' || input.name === 'variantId') {
            data.variantId = input.value;
          }
        });
      }

      if (!data.variantId) {
        const allElements = diamondCard.querySelectorAll('[data-variant-id], [data-product-id], [data-id]');
        for (const el of allElements) {
          const variantId = el.getAttribute('data-variant-id') || 
                           el.getAttribute('data-product-id') || 
                           el.getAttribute('data-id');
          if (variantId) {
            data.variantId = variantId;
            break;
          }
        }
      }

    } catch (error) {
      console.error('Error extracting diamond data:', error);
    }

    return data;
  }


  // ============================================
  // DIAMOND TRACKING
  // ============================================
  function trackDiamondInteraction(diamondCard, action) {
    // Track diamond interaction for analytics if needed
  }


  // ============================================
  // LOCAL STORAGE
  // ============================================
  function saveDiamondToStorage(diamondData) {
    try {
      localStorage.setItem('selectedDiamond', JSON.stringify(diamondData));
    } catch (error) {
      console.error('Error saving diamond to storage:', error);
    }
  }

  function loadDiamondFromStorage() {
    try {
      const saved = localStorage.getItem('selectedDiamond');
      if (saved) return JSON.parse(saved);
    } catch (error) {
      console.error('Error loading diamond from storage:', error);
    }
    return null;
  }

  function clearDiamondStorage() {
    try {
      localStorage.removeItem('selectedDiamond');
    } catch (error) {
      console.error('Error clearing diamond storage:', error);
    }
  }


  // ============================================
  // DIAMOND SELECTION CAPTURE ("Soft Add")
  // ============================================
  function captureDiamondSelection() {
    if (!NIVODA_CONFIG.features.captureAndHold) return;

    const originalFetch = window.fetch;
    
    // Intercept fetch to capture variant ID and prevent redirect
    window.fetch = async function(url, options = {}) {
      const urlString = url.toString().toLowerCase();

      if (urlString.includes('/cart/add') && options.method === 'POST') {
        if (window._isClickingDiamond) {
          try {
            let body;
            if (typeof options.body === 'string') {
              body = JSON.parse(options.body);
            } else {
              body = options.body;
            }

            const variantId = body.id || body.items?.[0]?.id;
            
            if (variantId) {
              if (window.selectedDiamond) {
                window.selectedDiamond.variantId = String(variantId);
                window.selectedDiamond.isSelected = true;
                saveDiamondToStorage(window.selectedDiamond);
                updateDiamondDisplay();
                scrollToProductInfo();
              }
              
              window._isClickingDiamond = false;
              
              // Return a never-resolving Promise to freeze Nivoda's script
              // This prevents their redirect code from executing
              return new Promise(() => {});
            }
          } catch (e) {
            console.error('Error intercepting fetch:', e);
          }
        }
      }

      return originalFetch.apply(this, arguments);
    };

    // Click listener to capture diamond data
    document.addEventListener('click', function(event) {
      const button = event.target.closest(NIVODA_CONFIG.selectors.button);
      if (!button) return;
      
      const diamondCard = button.closest(NIVODA_CONFIG.selectors.card);
      if (!diamondCard) return;

      window._isClickingDiamond = true;
      
      const diamondData = extractDiamondData(diamondCard);
      if (diamondData.title) {
        window.selectedDiamond = {
          ...diamondData,
          isSelected: false 
        };
      }
      
      setTimeout(() => { window._isClickingDiamond = false; }, 3000);

    }, true);
  }


  // ============================================
  // UI UPDATE
  // ============================================
  function updateDiamondDisplay() {
    updateStickyATCDiamond();
    
    if (NIVODA_CONFIG.features.showInProductInfo) {
      updateProductInfoDiamond();
    }
    
    document.dispatchEvent(new CustomEvent('diamond:selected', {
      detail: window.selectedDiamond
    }));
  }

  function updateStickyATCDiamond() {
    const stonePriceElement = document.getElementById('stone-price');
    if (stonePriceElement && window.selectedDiamond.isSelected) {
      stonePriceElement.textContent = window.selectedDiamond.priceFormatted || 'Selected';
      stonePriceElement.classList.add('selected');
    }
  }

  function updateProductInfoDiamond() {
    const event = new CustomEvent('nivoda:diamond-selected', {
      detail: window.selectedDiamond
    });
    window.dispatchEvent(event);
  }

  function scrollToProductInfo() {
    const productInfo = document.querySelector(NIVODA_CONFIG.selectors.productInfo);
    if (productInfo) {
      productInfo.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }


  // ============================================
  // ADD TO CART
  // ============================================
  function setupAddToCartInterception() {
    const productForms = document.querySelectorAll('form[action*="/cart/add"]');
    
    productForms.forEach(form => {
      form.addEventListener('submit', async function(e) {
        const hasDiamondFeed = document.querySelector('[data-component="feed"], .diamond-proxy-product-card');
        if (!hasDiamondFeed || !NIVODA_CONFIG.features.captureAndHold) return;

        if (window.selectedDiamond.isSelected && window.selectedDiamond.variantId) {
          e.preventDefault();
          
          const settingVariantInput = form.querySelector('input[name="id"]');
          if (!settingVariantInput) return;
          
          const settingVariantId = settingVariantInput.value;
          
          const submitButton = form.querySelector('[type="submit"]');
          if (submitButton) {
            submitButton.disabled = true;
            submitButton.textContent = 'Adding...';
          }
          
          try {
            await addBothToCart(settingVariantId, window.selectedDiamond.variantId);
            clearDiamondStorage();
            
            if (NIVODA_CONFIG.features.redirectToCart) {
              window.location.href = '/cart';
            }
          } catch (error) {
            console.error('Error adding to cart:', error);
            if (submitButton) {
              submitButton.disabled = false;
              submitButton.textContent = 'ADD TO BAG';
            }
            alert('There was an error adding items to your cart. Please try again.');
          }
        }
      });
    });
  }

  async function addBothToCart(settingVariantId, diamondVariantId) {
    const settingData = {
      id: settingVariantId,
      quantity: 1,
      properties: {
        'Diamond': window.selectedDiamond.title,
        'Diamond Price': window.selectedDiamond.priceFormatted,
        'Diamond Details': window.selectedDiamond.details,
      }
    };

    const diamondData = {
      id: diamondVariantId,
      quantity: 1,
    };

    const responses = await Promise.all([
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(settingData),
      }),
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(diamondData),
      }),
    ]);

    const results = await Promise.all(responses.map(r => r.json()));
    return results;
  }


  // ============================================
  // CARD ENHANCEMENT
  // ============================================
  function enhanceDiamondCard(card) {
    if (card.hasAttribute('data-enhanced')) return;
    card.setAttribute('data-enhanced', 'true');

    card.addEventListener('click', function(e) {
      trackDiamondInteraction(card, 'clicked');
    });
  }


  // ============================================
  // MUTATION OBSERVER
  // ============================================
  function watchNivodaCards() {
    const observer = new MutationObserver(function(mutations) {
      let hasNewCards = false;
      
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) {
            if (node.classList && node.classList.contains('diamond-proxy-product-card')) {
              hasNewCards = true;
              enhanceDiamondCard(node);
            } else if (node.querySelector && node.querySelector(NIVODA_CONFIG.selectors.card)) {
              hasNewCards = true;
              const cards = node.querySelectorAll(NIVODA_CONFIG.selectors.card);
              cards.forEach(card => enhanceDiamondCard(card));
            }
          }
        });
      });
      
      if (hasNewCards) customizeNivodaText();
    });
    
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    return observer;
  }


  // ============================================
  // RESTORE SAVED DIAMOND
  // ============================================
  function restoreSavedDiamond() {
    const saved = loadDiamondFromStorage();
    if (saved && saved.isSelected) {
      window.selectedDiamond = saved;
      updateDiamondDisplay();
    }
  }


  // ============================================
  // INITIALIZATION
  // ============================================
  function initializeExistingCards() {
    const cards = document.querySelectorAll(NIVODA_CONFIG.selectors.card);
    cards.forEach(card => enhanceDiamondCard(card));
  }

  function initNivodaCustomization() {
    restoreSavedDiamond();

    if (NIVODA_CONFIG.features.captureAndHold) {
      captureDiamondSelection();
      setupAddToCartInterception();
    }

    setupDiamondSelectionDisplay();

    setTimeout(customizeNivodaText, NIVODA_CONFIG.timing.initialDelay);
    setTimeout(customizeNivodaText, NIVODA_CONFIG.timing.secondCheck);
    setTimeout(customizeNivodaText, NIVODA_CONFIG.timing.thirdCheck);
    setTimeout(initializeExistingCards, NIVODA_CONFIG.timing.initialDelay);
    
    watchNivodaCards();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initNivodaCustomization);
  } else {
    initNivodaCustomization();
  }


  function scrollToDiamonds(event) {
    if (event) event.preventDefault();
    
    const nivodaSelectors = [
      '[data-component="feed"]',
      '[data-shapes]',
      '[id*="nivoda_connect_feed"]',
      '.diamond-proxy-product-card',
    ];

    let diamondSection = null;
    for (const selector of nivodaSelectors) {
      diamondSection = document.querySelector(selector);
      if (diamondSection) break;
    }

    if (diamondSection) {
      diamondSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }


  // ============================================
  // DIAMOND SELECTION DISPLAY
  // ============================================
  function updateDiamondSelectionDisplay(diamond) {
    const prompt = document.getElementById('diamond-prompt');
    const details = document.getElementById('diamond-details');

    if (!diamond || !diamond.isSelected) {
      if (prompt) prompt.classList.remove('hidden');
      if (details) details.classList.remove('show');
      return;
    }

    const typeEl = document.getElementById('diamond-type');
    const priceEl = document.getElementById('diamond-price');
    const titleEl = document.getElementById('diamond-title');
    const descriptionEl = document.getElementById('diamond-description');
    const certificateEl = document.getElementById('diamond-certificate');

    if (typeEl && diamond.type) typeEl.textContent = diamond.type;
    if (priceEl && diamond.priceFormatted) priceEl.textContent = diamond.priceFormatted;
    if (titleEl && diamond.title) titleEl.textContent = diamond.title;
    if (descriptionEl && diamond.details) descriptionEl.textContent = diamond.details;
    if (certificateEl && diamond.certificate) certificateEl.textContent = diamond.certificate;

    if (prompt) prompt.classList.add('hidden');
    if (details) details.classList.add('show');
    
    const stonePriceElement = document.getElementById('stone-price');
    if (stonePriceElement && diamond.priceFormatted) {
      stonePriceElement.textContent = diamond.priceFormatted;
      stonePriceElement.classList.add('selected');
    }
    
    if (typeof updateSelectionButton === 'function') {
      updateSelectionButton();
    }
  }

  function modifyDiamond() {
    if (window.selectedDiamond) {
      window.selectedDiamond.isSelected = false;
      clearDiamondStorage();
    }
    
    updateDiamondSelectionDisplay(null);
    
    if (typeof updateSelectionButton === 'function') {
      updateSelectionButton();
    }
    
    scrollToDiamonds();
  }

  function updateSettingPriceDisplay(event) {
    const settingPriceEl = document.getElementById('setting-price-value');
    if (settingPriceEl && event && event.detail && event.detail.variant && event.detail.variant.price) {
      let priceInPounds = event.detail.variant.price / 100;
      
      const isWeddingRing = document.body.classList.contains('template-product') && 
        (document.body.classList.contains('template-suffix-wedding-plain-band') || 
         document.body.classList.contains('template-suffix-wedding-diam-band') ||
         Array.from(document.body.classList).some(cls => cls.includes('eternity')));
      
      if (isWeddingRing) priceInPounds = Math.ceil(priceInPounds);
      
      const formatter = new Intl.NumberFormat('en-GB', {
        style: 'currency',
        currency: 'GBP',
        minimumFractionDigits: isWeddingRing ? 0 : 2,
        maximumFractionDigits: isWeddingRing ? 0 : 2,
      });
      settingPriceEl.textContent = formatter.format(priceInPounds);
    }
  }

  function setupDiamondSelectionDisplay() {
    window.addEventListener('nivoda:diamond-selected', function(event) {
      updateDiamondSelectionDisplay(event.detail);
    });

    document.addEventListener('diamond:selected', function(event) {
      updateDiamondSelectionDisplay(event.detail);
    });

    if (window.selectedDiamond && window.selectedDiamond.isSelected) {
      updateDiamondSelectionDisplay(window.selectedDiamond);
    }

    document.addEventListener('variant:change', updateSettingPriceDisplay);
    window.modifyDiamond = modifyDiamond;
  }


  // ============================================
  // GLOBAL API
  // ============================================
  window.NivodaCustom = {
    config: NIVODA_CONFIG,
    refresh: customizeNivodaText,
    enhance: enhanceDiamondCard,
    extractDiamondData: extractDiamondData,
    scrollToDiamonds: scrollToDiamonds,
    clearDiamondStorage: clearDiamondStorage,
    updateDiamondDisplay: updateDiamondSelectionDisplay,
    modifyDiamond: modifyDiamond,
  };

})();

